import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import jsoncsv from '../../components/jsoncsv.vue';
export default {
  __name: 'jsoncsvPage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "JSON 转 CSV / CSV 转 JSON",
        "current-page": "url"
      }, {
        default: _withCtx(() => [_createVNode(jsoncsv)]),
        _: 1
      });
    };
  }
};